"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModeSwitcher = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const utils_1 = require("@/utils");
require("@/components/common/toggle-button/toggle-button-group");
let ViewModeSwitcher = class ViewModeSwitcher extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = 'grid';
        this.options = [
            { value: 'grid', icon: icon_names_1.ICON_NAMES.GRID_VIEW, label: '그리드 보기' },
            { value: 'list', icon: icon_names_1.ICON_NAMES.LIST_VIEW, label: '목록 보기' },
        ];
    }
    render() {
        return (0, lit_1.html) `
      <mm-toggle-button-group
        hidden-label
        .options=${this.options}
        .value=${this.value}
        @change=${this.handleOptionChange}
      ></mm-toggle-button-group>
    `;
    }
    updateMode(mode) {
        this.value = mode;
        (0, utils_1.emit)(this, 'change', { value: this.value });
    }
    handleOptionChange(event) {
        event.stopPropagation();
        this.updateMode(event.detail.value);
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ViewModeSwitcher.prototype, "value", void 0);
ViewModeSwitcher = __decorate([
    (0, decorators_js_1.customElement)('mm-view-mode-switcher')
], ViewModeSwitcher);
exports.ViewModeSwitcher = ViewModeSwitcher;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlldy1tb2RlLXN3aXRjaGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidmlldy1tb2RlLXN3aXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBMkQ7QUFJM0Qsb0VBQWdFO0FBQ2hFLG1DQUE4QjtBQUM5QixpRUFBOEQ7QUFLdkQsSUFBTSxnQkFBZ0IsR0FBdEIsTUFBTSxnQkFBaUIsU0FBUSxnQkFBVTtJQUF6Qzs7UUFDdUIsVUFBSyxHQUFhLE1BQU0sQ0FBQTtRQUNuQyxZQUFPLEdBQWlCO1lBQ3ZDLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsdUJBQVUsQ0FBQyxTQUFTLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRTtZQUM5RCxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLHVCQUFVLENBQUMsU0FBUyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7U0FDOUQsQ0FBQTtJQXVCSCxDQUFDO0lBckJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7bUJBR0ksSUFBSSxDQUFDLE9BQU87aUJBQ2QsSUFBSSxDQUFDLEtBQUs7a0JBQ1QsSUFBSSxDQUFDLGtCQUFrQjs7S0FFcEMsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVLENBQUMsSUFBYztRQUMvQixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQTtRQUVqQixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsUUFBUSxFQUFFLEVBQUUsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFBO0lBQzdDLENBQUM7SUFFTyxrQkFBa0IsQ0FBQyxLQUF1QztRQUNoRSxLQUFLLENBQUMsZUFBZSxFQUFFLENBQUE7UUFDdkIsSUFBSSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQ3JDLENBQUM7Q0FDRixDQUFBO0FBM0I2QjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7K0NBQXlCO0FBRHpDLGdCQUFnQjtJQUQ1QixJQUFBLDZCQUFhLEVBQUMsdUJBQXVCLENBQUM7R0FDMUIsZ0JBQWdCLENBNEI1QjtBQTVCWSw0Q0FBZ0IifQ==